export enum CollectionModerationTab {
  AllItems = 'all-items',
  Moderators = 'moderators',
  Settings = 'settings',
}
